import { Controller } from 'stimulus'

export default class extends Controller {
    static get targets () {
        return ['modal']
    }

    show () {
        this.modalTargets.forEach(el => el.classList.remove('hidden'))
    }

    hide () {
        this.modalTargets.forEach(el=> el.classList.add('hidden'))
    }
}



// WEBPACK FOOTER //
// ./assets/js/controllers/SharingController.js